import { Reveal } from "../Reveal";

const PRODUCTS = [
  {
    id: "mens",
    title: "Men's Footwear",
    desc: "Oxfords, derbies, brogues, loafers — refined silhouettes from a workshop that respects tradition.",
    img: "https://images.unsplash.com/photo-1563433337461-5b65f0834f3a?crop=entropy&cs=srgb&fm=jpg&q=85",
    size: "lg",
  },
  {
    id: "moccasins",
    title: "True Moccasins",
    desc: "Hand-lasted, hand-stitched, full-grain leather — moccasins as they were meant to be made.",
    img: "https://static.prod-images.emergentagent.com/jobs/3adc9213-dab6-4851-9c35-a0c85e7e3dfd/images/7f5a6546f6224d6dfce9b54b149a631e0ebda49192f18c8116c2c721221bf28e.png",
    size: "md",
  },
  {
    id: "ladies",
    title: "Ladies' Footwear",
    desc: "Ballet flats, loafers, mules and boots — silhouettes balancing softness with structure.",
    img: "https://static.prod-images.emergentagent.com/jobs/3adc9213-dab6-4851-9c35-a0c85e7e3dfd/images/58af23d9684d3ebfe151f00158c74025ebcb80f78407499177520a01a2f0732e.png",
    size: "md",
  },
  {
    id: "welted",
    title: "Goodyear Welted",
    desc: "Resoleable, water-resistant, built to outlast trends — our welted line is the house's pride.",
    img: "https://images.unsplash.com/photo-1616406432452-07bc5938759d?crop=entropy&cs=srgb&fm=jpg&q=85",
    size: "lg",
  },
  {
    id: "garments",
    title: "Leather Garments",
    desc: "Jackets, vests and outerwear cut and stitched alongside our footwear — same hands, same standard.",
    img: "https://static.prod-images.emergentagent.com/jobs/3adc9213-dab6-4851-9c35-a0c85e7e3dfd/images/6f16003a579fe19e8fe2baa02126b8751a153ad100b4718280f81fb0f12c6b92.png",
    size: "md",
  },
  {
    id: "kids",
    title: "Kids' Footwear",
    desc: "Real leather, kinder lasts — small shoes built with the same craft as their grown-up counterparts.",
    img: "https://images.pexels.com/photos/267301/pexels-photo-267301.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
    size: "md",
  },
];

export const Collections = () => {
  return (
    <section
      id="collections"
      data-testid="collections-section"
      className="relative py-24 md:py-40 bg-[#F3F0EA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 md:mb-24">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="text-[11px] tracking-[0.3em] uppercase text-[#B8945F] font-medium">
                03 — Collections
              </span>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={100}>
              <h2
                data-testid="collections-heading"
                className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#0F1B3D] leading-[1.05] tracking-tight"
              >
                Six houses, <em className="font-light">one</em> standard of craft.
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-6 max-w-xl text-[15px] md:text-base text-[#1A1A1A]/70 leading-relaxed">
                Every collection below is fully customisable — leathers, lasts, soles, linings, hardware, packaging. Tell us what your customer expects, and we'll build it.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Editorial bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6">
          {PRODUCTS.map((p, idx) => {
            const span =
              p.size === "lg"
                ? "md:col-span-4"
                : "md:col-span-2";
            const aspect =
              p.size === "lg"
                ? "aspect-[16/10] md:aspect-[5/3]"
                : "aspect-[4/5] md:aspect-[3/4]";
            return (
              <Reveal
                key={p.id}
                delay={idx * 80}
                className={span}
              >
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  data-testid={`collection-card-${p.id}`}
                  className={`group relative block zoom-container ${aspect} overflow-hidden`}
                >
                  <img
                    src={p.img}
                    alt={p.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F1B3D] via-[#0F1B3D]/30 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-700" />
                  <div className="absolute inset-0 p-6 md:p-10 flex flex-col justify-end text-[#F9F8F6]">
                    <span className="text-[10px] tracking-[0.3em] uppercase text-[#B8945F] mb-3">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight mb-3 leading-[0.95]">
                      {p.title}
                    </h3>
                    <p className="text-[13px] md:text-sm max-w-md text-[#F9F8F6]/80 leading-relaxed">
                      {p.desc}
                    </p>
                    <div className="mt-6 flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase">
                      <span className="w-8 h-px bg-[#B8945F] group-hover:w-16 transition-all duration-500" />
                      <span>Enquire</span>
                    </div>
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
